import { proxy, useSnapshot } from 'valtio'

const liveTranscriptionsEnabledState = proxy<{ enabled: boolean }>({
  enabled: true,
})

const useAreLiveTranscriptionsEnabled = () =>
  useSnapshot(liveTranscriptionsEnabledState).enabled

const toggleLiveTranscriptions = () => {
  liveTranscriptionsEnabledState.enabled =
    !liveTranscriptionsEnabledState.enabled
}

export {
  liveTranscriptionsEnabledState,
  toggleLiveTranscriptions,
  useAreLiveTranscriptionsEnabled,
}
